import React, { Component } from 'react';
import { BiEnvelope } from 'react-icons/bi'
import DB from 'data/db.json';

class FooterSection extends Component {
  state = {
    data: {},
    iconList: [],
    footerList_1: [],
    footerList_2: [],
    footerList_3: [],
  };
  componentDidMount() {
    this.setState({
      data: DB.FooterSection,
      iconList: DB.FooterSection.iconList,
      footerList_1: DB.FooterSection.footerList_1,
      footerList_2: DB.FooterSection.footerList_2,
      footerList_3: DB.FooterSection.footerList_3,
    });
  }
  render() {
    return (
      <div>
        <div className="height-emulator d-none d-lg-block" />
        <footer className="footer-area footer-fixed">
          {/* Footer Top */}
          <div className="footer-top ptb_100">
            <div className="container">
              <div className="row">
                <div className="col-12 col-sm-6 col-lg-4">
                  {/* Footer Items */}
                  <div className="footer-items">
                    {/* Logo */}
                    <a className="navbar-brand" href="/#">
                      <img src={this.state.data.image} alt="logo lqra" height={200}/>
                    </a>
                    <p className="mt-2 mb-3">{this.state.data.text}</p>
                    {/* Social Icons */}
                    <div className="social-icons d-flex">
                      <a href="#contact" className="media"><BiEnvelope className="google-plus"/>consultaslqra@gmail.com</a>


                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-4">
                  {/* Footer Items */}
                  <div className="footer-items">
                    {/* Footer Title */}
                    <h3 className="footer-title mb-2">{this.state.data.linkText_1}</h3>
                    <ul>
                      {this.state.footerList_1.map((item, idx) => {
                        return (
                          <li key={`flo_${idx}`} className="py-2">
                            <a href={item.link}>{item.text}</a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-4">
                  {/* Footer Items */}
                  <div className="footer-items">
                    {/* Logo UNL */}
                    <img
                        src={process.env.PUBLIC_URL + '/img/unl3lineas.png'}
                        align="center"
                        alt="Logo Santa Fe"
                        height={150}
                      />

                  </div>
                </div>

              </div>
            </div>
          </div>
          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {/* Copyright Area */}
                  <div className="copyright-area d-flex flex-wrap justify-content-center justify-content-sm-between text-center py-4">
                    {/* Copyright Left */}
                    <div className="copyright-left">Laboratorio de Química en Realidad Aumentada.</div>
                    {/* Copyright Center */}
                    <div className="copyright-center">~ 2022 ~</div>
                    {/* Copyright Right */}
                    <div className="copyright-right">
                      Diseño y Desarrollo: <a href="https://josecgallo.ar">josecgallo.ar</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default FooterSection;
